/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Dialog_DescriptionInputs */

const vi_import_dialog_description = /** @type {(inputs: Import_Dialog_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đối chiếu theo số điện thoại. Số điện thoại đã có trong hệ thống sẽ được giữ nguyên thông tin; số điện thoại chưa có sẽ được tạo thành khách mới.`)
};

/**

* @param {Import_Dialog_DescriptionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const import_dialog_description = /** @type {((inputs?: Import_Dialog_DescriptionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Dialog_DescriptionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_import_dialog_description(inputs)
});